import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_campaign_event_RowClass } from '../../../dbschema/bl_dgmkt_campaign_event.model';

export class DgMktCampaignEventContainerModel extends BaseContainerModel {
  bl_dgmkt_campaign_event: bl_dgmkt_campaign_event_RowClass =
    new bl_dgmkt_campaign_event_RowClass();
}
